import { energyEfficiencyCertificateService } from '@modules/energy-efficiency-certificate/infrastructure/energy-efficiency-certificate.service'
import { EnergyEfficiencyCertificateOption } from '@modules/energy-efficiency-certificate/domain/energy-efficiency-certificate.types'

type Callbacks = {
  onOptions: (options: Array<EnergyEfficiencyCertificateOption>) => void
  onNetworkError: (error: unknown) => void
}

export function getEnergyEfficiencyCertificateOptions() {
  return { execute }

  async function execute({ onOptions, onNetworkError }: Callbacks) {
    try {
      const options = await energyEfficiencyCertificateService.getOptions()
      onOptions(options)
    } catch (error) {
      onNetworkError(error)
    }
  }
}
